import { find, get } from 'lodash';
import format from 'date-fns/format';

import { GEO_DEBUG } from '../../modules/Geolocation/util';

export const fromAddressResponse = (address = {}) => {
  const addressResponse = {
    addressId: address.id,
    addressState: address.state,
    city: address.city,
    streetAddress: address.addressLineOne,
    secondaryStreetAddress: address.addressLineTwo,
    zipCode: address.zip,
    latitude: address.latitude,
    longitude: address.longitude,
  };

  if (GEO_DEBUG) {
    // Debug: Override geofence lat/long with these Pittsburgh coordinates
    addressResponse.latitude = 40.440624;
    addressResponse.longitude = -79.995888;
  }

  return addressResponse;
};

export const toAddressRequest = address => ({
  addressId: address.addressId,
  addressLineOne: address.streetAddress,
  addressLineTwo: address.secondaryStreetAddress,
  city: address.city,
  state: address.addressState,
  zip: address.zipCode,
  latitude: address.latitude,
  longitude: address.longitude,
});

export const enumToString = (enumCollection, value) =>
  get(
    find(enumCollection, item => item.value === value),
    'label',
  );

export function toISOStringNoZone(date) {
  return format(date, 'YYYY-MM-DDTHH:mm:ss');
}



// WEBPACK FOOTER //
// ./src/lib/dataLayer/util.js